import { useState } from 'react';
import IconFile from '../../components/Icon/IconFile';
import IconHome from '../../components/Icon/IconHome';
import IconStar from '../../components/Icon/IconStar';
import IconDollarSignCircle from '../../components/Icon/IconDollarSignCircle';
import IconListCheck from '../../components/Icon/IconListCheck';

import DashboardTabComp from '../../components/DashboardComponents/DashboardTabComp';
import AMDMProductivityTab1 from '../../components/pagecomponents/DashboardComp/AMDMComp/AMDMProductivityTab1';
import AMDMQualityTab1 from '../../components/pagecomponents/DashboardComp/AMDMComp/AMDMQualityTab1';
import AMDMLeakageTab from '../../components/pagecomponents/DashboardComp/AMDMComp/AMDMLeakageTab';
import ProductionData from '../../Data/DashboardData/UserLevelDBProductionData.json';
import Rating from '../Dashboard/Rating';
import AssistantManagerRatings from '../../components/Layouts/context/Incentive/AssistantManagerRatings';
import { IconLayersDifference, IconLayoutList } from '@tabler/icons-react';

function AMDMMainTab() {
  const [activeTab, setActiveTab] = useState(0); // State to track active tab

  const tabs = [
    {
      label: 'Production',
      icon: IconHome,
      header: '',
      component: <AMDMProductivityTab1 />,
      data: ProductionData,
    },
    // {
    //   label: 'Production-View2',
    //   icon: IconHome,
    //   header: '',
    //   component: <AMDMProductivityTab2 />,
    //   data: ProductionData,
    // },

    // {
    //   label: 'Quality',
    //   icon: IconStar,
    //   header: '',
    //   component: <AMDMQualityTab1 />,
    //   data: '',
    // },
    // {
    //   label: 'Revenue',
    //   icon: IconDollarSignCircle,
    //   header: '',
    //   component: <AMDMRevenueTab />,
    //   data: '',
    // },
    // {
    //   label: 'Compliance',
    //   icon: IconListCheck,
    //   header: '',
    //   component: <AMDMComplianceTab />,
    //   data: '',
    // },
    // {
    //   label: 'Quality',
    //   icon: IconStar,
    //   header: '',
    //   component: <AMDMQualityTab1 />,
    //   data: '',
    // },
    // {
    //   label: 'Revenue',
    //   icon: IconDollarSignCircle,
    //   header: '',
    //   component: <AMDMRevenueTab />,
    //   data: '',
    // },
    // {
    //   label: 'Compliance',
    //   icon: IconListCheck,
    //   header: '',
    //   component: <AMDMComplianceTab />,
    //   data: '',
    // },
    {
      label: 'Leakage',
      icon: IconListCheck,
      header: '',
      component: <AMDMLeakageTab />,
      data: '',
    }, 
    {
      label: 'Quality',
      icon: IconStar,
      header: '',
      component: <AMDMQualityTab1 />,
      data: '',
    },
    {
      label: 'Ratings',
      icon: IconStar,
      header: '',
      component: <Rating />,
      data: '',
    },
     {
      label: 'PBI/BQM',
      icon: IconLayoutList,
      header: '',
      component: <AssistantManagerRatings />,
      data: '',
    },
    // {
    //   label: 'Revenue',
    //   icon: IconDollarSignCircle,
    //   header: '',
    //   component: <AMDMRevenueTab />,
    //   data: '',
    // },
    // {
    //   label: 'Compliance',
    //   icon: IconListCheck,
    //   header: '',
    //   component: <AMDMComplianceTab />,
    //   data: '',
    // },
  ];
  return (
    <>
      {/* <DashboardDropdown /> */}
      <DashboardTabComp
        tabs={tabs}
        activeTab={activeTab} // Pass activeTab to manage which tab is selected
        onTabChange={setActiveTab} // Pass setActiveTab to update activeTab state
        data={tabs[activeTab]?.data} // Pass data of the currently active tab
      />
    </>
  );
}
export default AMDMMainTab;
